(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["memberships-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMembershipInquiries = (scope = document) => {
      scope.querySelectorAll('[data-membership-inquiry]').forEach((dialog) => {
        if (dialog.dataset.initialized === 'true') return;
        dialog.dataset.initialized = 'true';

        const section = dialog.closest('[data-memberships-catalog]');
        const openers = section?.querySelectorAll('[data-membership-inquiry-open]') || [];
        const closeButtons = dialog.querySelectorAll('[data-membership-inquiry-close]');
        const name = dialog.querySelector('[data-membership-inquiry-name]');
        const price = dialog.querySelector('[data-membership-inquiry-price]');
        const frequency = dialog.querySelector('[data-membership-inquiry-frequency]');
        let activeOpener = null;

        const closeDialog = () => {
          if (dialog.open) dialog.close();
        };

        openers.forEach((opener) => {
          opener.addEventListener('click', () => {
            if (typeof dialog.showModal !== 'function') return;

            activeOpener = opener;
            name.textContent = opener.dataset.membershipName || 'Por definir';
            price.textContent = opener.dataset.membershipPrice || 'Por definir';
            frequency.textContent = opener.dataset.membershipFrequency || 'Por definir';

            dialog.showModal();
            dialog.querySelector('.membership-inquiry__close')?.focus({ preventScroll: true });
          });
        });

        closeButtons.forEach((button) => button.addEventListener('click', closeDialog));

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeDialog();
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeDialog();
        });

        dialog.addEventListener('close', () => {
          activeOpener?.focus({ preventScroll: true });
          activeOpener = null;
        });
      });
    };

    initializeMembershipInquiries();
    document.addEventListener('shopify:section:load', (event) => initializeMembershipInquiries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHandoff = (scope = document) => {
      scope.querySelectorAll('[data-booking-handoff]').forEach((dialog) => {
        if (dialog.dataset.initialized === 'true') return;
        dialog.dataset.initialized = 'true';

        const section = dialog.closest('.services-page');
        const openers = section?.querySelectorAll('[data-handoff-open]') || [];
        const closeButtons = dialog.querySelectorAll('[data-handoff-close]');
        const continueLink = dialog.querySelector('[data-handoff-continue]');
        const details = dialog.querySelector('[data-handoff-details]');
        const service = dialog.querySelector('[data-handoff-service]');
        const duration = dialog.querySelector('[data-handoff-duration]');
        const price = dialog.querySelector('[data-handoff-price]');
        let activeOpener = null;

        const closeDialog = () => {
          if (dialog.open) dialog.close();
        };

        openers.forEach((opener) => {
          opener.addEventListener('click', (event) => {
            if (typeof dialog.showModal !== 'function') return;

            event.preventDefault();
            activeOpener = opener;

            const hasService = Boolean(opener.dataset.serviceName);
            details.hidden = !hasService;

            if (hasService) {
              service.textContent = opener.dataset.serviceName;
              duration.textContent = opener.dataset.serviceDuration || 'Duración por confirmar al reservar';
              price.textContent = opener.dataset.servicePrice || 'Consultar en Fresha';
            }

            dialog.showModal();
            dialog.querySelector('.booking-handoff__close')?.focus({ preventScroll: true });
          });
        });

        closeButtons.forEach((button) => button.addEventListener('click', closeDialog));
        continueLink?.addEventListener('click', closeDialog);

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeDialog();
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDialog();
          }
        });

        dialog.addEventListener('close', () => {
          activeOpener?.focus({ preventScroll: true });
          activeOpener = null;
        });
      });
    };

    initializeHandoff();
    document.addEventListener('shopify:section:load', (event) => initializeHandoff(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
